import formatWork from "../format/work";
import queryByDocType from "../queryByDocType";

export default async () => {
	const work = await queryByDocType("work");
	return work.map(formatWork);
};
